<template>
    <simple-layout>
        <basic-card>
            <form-wrapper :columns="2">
                <form-text-input :caption="calculationResultCaption" v-model="calculationResult"/>
                <simple-button @press="handleCalculateComparison" style="width: 100%">
                    {{ $t('comparison.run') }}
                </simple-button>
            </form-wrapper>
        </basic-card>
        <basic-card>
            <template>
                <div class="tab-navigation">
                    <div
                      v-for="(tab, index) in comparison.tabs"
                      :key="`${tab.name}${index}`"
                      class="tab-navigation__item"
                      :class="{'tab-navigation__item--active' : isTabSelected(tab)}"
                      @click.prevent="setActiveTab(tab)">
                        {{ tabNames[index] }}
                    </div>
                    <div id="add-button" class="tab-navigation__item">
                        <simple-button @press="handleAddNewTab">
                            <icon :icon="['fal', 'plus']"/>
                        </simple-button>
                    </div>
                </div>
                <div class="tab-detail">

                    <comparison-tab
                      v-for="(tab, index) in comparison.tabs"
                      v-show="selectedTab === tab"
                      :ref="`tab-card${index + 1}`"
                      :value="tab"
                      @input="newValue => tab = newValue"
                      @tab-changed="handleTabChanged(index)"
                    />
                </div>
            </template>
        </basic-card>
    </simple-layout>


</template>

<script>

import ComparisonCard from "@/components/ComparisonCard";
import SimpleLayout from "@/components/layout/SimpleLayout";
import FormTextInput from "@/components/form/FormTextInput";
import BasicCard from "@/components/layout/BasicCard";
import FormWrapper from "@/components/form/FormWrapper";
import SimpleButton from "@/components/button/SimpleButton";
import ComparisonTab from "@/components/ComparisonTab";
import SimpleHorizontalLayout from "@/components/layout/SimpleHorizontalLayout";
import { mapGetters } from "vuex";

export default {
    name: "ComparisonView",
    components: {
        SimpleHorizontalLayout,
        ComparisonTab,
        SimpleButton,
        FormWrapper,
        BasicCard,
        FormTextInput,
        ComparisonCard,
        SimpleLayout,
    },
    data: function () {
        return {

            comparison: {
                name: 'Nazev do zalozky',
                tabs: [
                    {
                        "name": "Tab 1",
                        'operator': '+',
                        "operationDefinitionId": "625e6590984cd17acbba672e",
                        "attribute": "amount",
                        "filters": [{
                            "attributes": {
                                "parameters": {
                                    "content.values.amount": {
                                        "type": "float",
                                        "operator": "range",
                                        "value": "10000;15000",
                                        "negation": false
                                    }
                                }
                            }, "operator": "ADD"
                        }, {
                            "attributes": {
                                "parameters": {
                                    "content.values.amount": {
                                        "type": "float",
                                        "operator": "range",
                                        "value": "20000;25000",
                                        "negation": false
                                    }
                                }
                            }, "operator": "ADD"
                        }],
                        operationsList: [],
                    },
                    {
                        "name": "Tab 2",
                        "operator": "+",
                        "operationDefinitionId": "624179f8984cd17acbba66eb",
                        "attribute": "amount",
                        "filters": [{
                            "attributes": {
                                "parameters": {
                                    "content.values.amount": {
                                        "type": "float",
                                        "operator": "lt",
                                        "value": 0,
                                        "negation": false
                                    },
                                    "operationDefinition": {
                                        "operator": "eq",
                                        "value": "624179f8984cd17acbba66eb",
                                        "type": "string",
                                        "negation": false
                                    }
                                }
                            }, "operator": "ADD"
                        }],
                        "operationsList": []
                    }],
            },
            calculationResult: 0,
            calculationResultCaption: '',
            selectedTab: {},

            tabResults: [],
            tabNames: []
        }
    },
    computed: {

        ...mapGetters({
            getOperationDefinition: "operationDefinitions/operationDefinition",
        }),
    },
    methods: {

        handleAddNewTab() {
            const emptyTab = {
                name: `Záložka ${this.comparison.tabs.length + 1}`,
                operationId: '',
                attribute: '',
                filters: []
            }
            this.comparison.tabs.push(emptyTab);
            this.setTabNames();
        },

        setActiveTab(tab) {
            this.selectedTab = tab;
        },

        isTabSelected(tab) {
            return tab === this.selectedTab;
        },

        async handleCalculateComparison() {

            const calculateTab = async (tab, index) => {
                //Better use is with store
                const references = this.$refs[`tab-card${index + 1}`];
                const result = await references[0].calculateResult()
                return {
                    result,
                    operator: tab.operator
                }
            };

            const summarizationTabResults = (prev, cur) => {

                const numeralValue = this.$numeral(cur.result).value();
                const withOperator = numeralValue * (cur.operator === '+' ? 1 : -1);

                return prev + withOperator;
            };

            this.tabResults = await Promise.all(this.comparison.tabs.map(calculateTab));

            this.setTabNames();

            const sumOfTabsResults = this.tabResults.reduce(summarizationTabResults, 0);

            this.calculationResult = this.$numeral(sumOfTabsResults).format('0,0.00')
            this.calculationResultCaption = this.comparison.tabs.map((tab, index) => `${this.tabResults[index].operator} [${tab.name}]`).join(' ') + '=';
        },

        setTabNames() {

            const createTabName = (tab, index) => {

                const tabResult = this.tabResults[index];
                const resultString = tabResult ? `(${tabResult.result})` : '';

                return `${tab.name} ${resultString}`
            };

            this.tabNames = this.comparison.tabs.map(createTabName);
        },

        handleTabChanged(tabIndex) {

            this.calculationResult = '';
            this.calculationResultCaption = '';

            this.tabResults[tabIndex] = undefined;

            this.setTabNames();
        }
    },
    mounted() {
        //TODO after change comparison/ comparisonId
        this.setTabNames();

        if (this.comparison.tabs.length) this.setActiveTab(this.comparison.tabs[0]);
    }
}
</script>

<style lang="scss" scoped>

@import "../styles/global";

.tab-navigation {
    padding-left: 5px;
    color: whitesmoke;
    text-align: left;

    &__item {
        display: inline-block;
        padding: 8px;
        margin: 2px 0 2px 0;
        background-color: var(--card-background-color);

        &:hover {
            background-color: transparentize(lighten(#262C32, 5), 0.5);
            cursor: pointer;
        }

        &--active {
            background-color: lighten($backgroundColor, 20);
        }
    }

    #add-button {
        line-height: 1.5em;
        border-right: none;

        &:hover {
            background-color: var(--card-background-color);
            border-bottom: none;
            cursor: default;
        }
    }
}
</style>
